export default (langVar, fallback) => {
  return window.locale ? window.locale[langVar] || fallback : fallback;
}
